export function popoverApiSupport(){
  return Object.hasOwn(HTMLElement.prototype, 'popover');
}
